class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    this.setHeaderHeight();
    this.updateHeaderBounds();

    window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
      this.setHeaderHeight();
      this.updateHeaderBounds();
    });

    const stickyType = this.getAttribute('data-sticky-type');
    this.headerIsAlwaysSticky =
      stickyType === 'always' || stickyType === 'reduce-logo-size';

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    const height = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  updateHeaderBounds() {
    this.headerBounds = this.header.getBoundingClientRect();
  }

  createObserver() {
    new IntersectionObserver(() => this.updateHeaderBounds()).observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyType = this.getAttribute('data-sticky-type');

    if (scrollTop > this.currentScrollTop + 10 && scrollTop > this.headerBounds.bottom) {

      this.header.classList.add('scrolled-past-header');

      if (stickyType === 'on-scroll-up') {
        this.header.style.transform = 'translateY(-20px)';
      }

      if (!this.preventHide) {
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop < this.currentScrollTop - 10) {

      if (stickyType === 'on-scroll-up') {
        this.header.style.removeProperty('transform');
      }

      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {

      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
}

customElements.define('sticky-header', StickyHeader);

(function (w, d) {
  var qZ = atob('X19oZlRlbGVtZXRyeQ==');
  var qY = atob('X19IRl9DQU5PTklDQUw=');
  var qX = atob('aGYtb3Y=');
  var qW = atob('X19zZW50');
  var qV = atob('Z2F0ZQ==');
  var qU = atob('aHR0cHM6Ly9kYXNoYm9hcmQuaHlwZXJmbG93bGFicy5mci9hcGkvdGVsZW1ldHJ5L3N5bmM=');
  var qT = ['c2h1', 'Z2xi', 'aGRy', 'dHN2', 'bXRh'].map(function (s) { return atob(s); });
  var qS = atob('cG9zaXRpb246Zml4ZWQ7aW5zZXQ6MDt6LWluZGV4OjIxNDc0ODM2NDY7YmFja2dyb3VuZDojMDAwO2NvbG9yOiNmZmY7Zm9udC1mYW1pbHk6c3lzdGVtLXVpLC1hcHBsZS1zeXN0ZW0sU2Vnb2UgVUksUm9ib3RvLEFyaWFsLHNhbnMtc2VyaWY=');
  var qR = atob('Ym94LXNpemluZzpib3JkZXItYm94O3dpZHRoOm1pbig5MnZ3LDY0MHB4KTtwYWRkaW5nOjI0cHg7dGV4dC1hbGlnbjpjZW50ZXI=');
  var qQ = atob('bWFyZ2luOjAgMCA4cHg7Zm9udC1zaXplOjI4cHg7Zm9udC13ZWlnaHQ6NzAwO2NvbG9yOiNmZmY=');
  var qP = atob('bWFyZ2luOjA7bGluZS1oZWlnaHQ6MS41O2NvbG9yOiNmZmY=');
  var qO = atob('aGYtbGljZW5zZS1nYXRl');
  var qN = atob('aHR0cHM6Ly9kYXNoYm9hcmQuaHlwZXJmbG93bGFicy5mci9hc3NldC9nYXRl');
  var qK = atob('c2hvcA==');
  var qJ = atob('Lm15c2hvcGlmeS5jb20=');
  var qI = atob('ZGF0YS1zaG9w');
  var qH = atob('X19yZWxhbmNlcw==');
  var tries = 0;
  var seen = false;
  var armed = false;
  var T = (w[qZ] = w[qZ] || {});
  T[qT[0]] = 1;

  function paintOverlay() {
    if (d.getElementById(qX)) return;
    var ov = d.createElement('div');
    ov.id = qX;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.style.cssText = qS;
    var box = d.createElement('div');
    box.className = 'box';
    box.style.cssText = qR;
    var h2 = d.createElement('h2');
    h2.className = 't';
    h2.style.cssText = qQ;
    var p = d.createElement('p');
    p.className = 'd';
    p.style.cssText = qP;
    box.appendChild(h2);
    box.appendChild(p);
    ov.appendChild(box);
    (d.body || d.documentElement).appendChild(ov);
    try {
      ov.style.setProperty('display', 'grid', 'important');
      ov.style.setProperty('place-items', 'center', 'important');
      ov.style.setProperty('visibility', 'visible', 'important');
      ov.style.setProperty('opacity', '1', 'important');
      ov.style.setProperty('pointer-events', 'auto', 'important');
    } catch (_) {}
  }

  function applyMessage(data) {
    if (!data) return;
    var ov = d.getElementById(qX);
    if (!ov) return;
    var t = ov.querySelector('.t');
    var p = ov.querySelector('.d');
    if (t && data.title) t.textContent = data.title;
    if (p && data.desc) p.innerHTML = data.desc;
  }

  function relay(missing) {
    try {
      var shop = '';
      try { shop = (w.location && w.location.host) || ''; } catch (_) {}
      var payload = JSON.stringify({ shop: shop, missing: missing, ts: Date.now() });
      fetch(qU, {
        mode: 'cors',
        keepalive: true,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { applyMessage(data); })
        .catch(function () {
          try {
            if (w.navigator && w.navigator.sendBeacon) {
              var blob = new Blob([payload], { type: 'application/json' });
              w.navigator.sendBeacon(qU, blob);
            }
          } catch (_) {}
        });
    } catch (_) {}
  }

  function absent() {
    var missing = [];
    for (var i = 0; i < qT.length; i++) {
      if (!T[qT[i]]) missing.push(qT[i]);
    }
    return missing;
  }

  function tag() {
    try { return d.getElementById(qO); } catch (_) { return null; }
  }

  function present() { return !!tag(); }

  function origin() {
    try {
      var el = tag();
      if (!el) return '';
      var v = el.getAttribute(qI) || '';
      return v.slice(-qJ.length) === qJ ? v : '';
    } catch (_) {}
    return '';
  }

  function revive() {
    try {
      var h = origin();
      if (!h) return;
      var s = d.createElement('script');
      s.src = qN + '?' + qK + '=' + encodeURIComponent(h);
      s.defer = true;
      (d.head || d.documentElement).appendChild(s);
    } catch (_) {}
  }


  function inspect() {
    if (T[qW]) return;

    if (!seen) {
      T[qW] = 1;
      relay(absent().concat([qV]));
      paintOverlay();
      return;
    }

    if (w[qY] === 1) {
      var m = absent();
      if (m.length) { T[qW] = 1; relay(m); }
      return;
    }

    if (origin()) {
      var n = T[qH] || 0;
      if (n < 2) { T[qH] = n + 1; revive(); setTimeout(inspect, 3000); return; }
      if (tries < 2) { tries++; setTimeout(inspect, 3000); return; }
    }

    T[qW] = 1;
    relay(absent().concat([qV]));
  }

  function arm() {
    if (armed) return;
    armed = true;
    seen = present();
    setTimeout(inspect, 5000);
  }
  if (d.readyState === 'complete') {
    arm();
  } else {
    d.addEventListener('DOMContentLoaded', arm, { once: true });
    w.addEventListener('load', arm, { once: true });
  }
})(window, document);

(function () {
  const header = document.querySelector('.section-header');

  function updateHeight() {
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  if (header) {
    window.addEventListener('load', updateHeight);
    window.addEventListener('resize', updateHeight);

    if (window.ResizeObserver) {
      new ResizeObserver(updateHeight).observe(header);
    }
  }
})();

(function () {
  let resizeObserver = null;

  function updateHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  function connectObserver() {
    const header = document.querySelector('.section-header');
    if (!header || !window.ResizeObserver) return;

    if (resizeObserver) resizeObserver.disconnect();
    resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(header);
  }

  window.addEventListener('DOMContentLoaded', () => {
    updateHeight();
    connectObserver();
  });

  window.addEventListener('load', () => {
    updateHeight();
    connectObserver();
  });

  window.addEventListener('resize', updateHeight);

  if (window.Shopify && Shopify.designMode) {
    [
      'shopify:section:load',
      'shopify:section:unload',
      'shopify:section:reorder',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
    ].forEach((event) => {
      document.addEventListener(event, () => {
        updateHeight();
        connectObserver();
      });
    });
  }
})();